import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const PaymentVerify = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("در حال بررسی پرداخت...");

  useEffect(() => {
    const success = searchParams.get("success");
    const ref = searchParams.get("ref");

    if (success === "true") {
      setStatus(`✅ پرداخت با موفقیت انجام شد. کد پیگیری: ${ref}`);
    } else {
      setStatus("❌ پرداخت ناموفق بود یا توسط کاربر لغو شد.");
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-xl shadow text-center space-y-4 max-w-md w-full">
        <h1 className="text-xl font-bold text-green-700">نتیجه پرداخت</h1>
        <p className="text-gray-700">{status}</p>
        <a
          href="/"
          className="text-green-700 underline font-semibold text-sm block"
        >
          بازگشت به خانه
        </a>
      </div>
    </div>
  );
};

export default PaymentVerify;
